// Categories Data

import { v4 as uuid } from 'uuid'

export const categories = [
  {
    _id: uuid(),
    thumbnail:
      'https://i.ytimg.com/vi/D6QM3Xed2J0/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAf7CiFYfUks7dtieegGd3O_eK1hg',
    src: 'https://www.youtube.com/embed/D6QM3Xed2J0',
    category: 'Origami',
  },
  {
    _id: uuid(),
    thumbnail:
      'https://i.ytimg.com/vi/cScuMgYHKeM/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDD_1sAD2_ui20Zj1zIv6Fux5UkOQ',
    src: 'https://www.youtube.com/embed/cScuMgYHKeM',
    category: 'Kirigami',
  },
  {
    _id: uuid(),
    thumbnail:
      'https://i.ytimg.com/vi/HouoBQcr3zU/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCNFI1TM_2gcAVp49ZA14dHh-cC2g',
    src: 'https://www.youtube.com/embed/HouoBQcr3zU',
    category: 'Clay Modeling',
  },
  {
    _id: uuid(),
    thumbnail:
      'https://i.ytimg.com/vi/CJ7LQXgp81w/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLC-UdpvOWsImcY4MX8ITgBa7PbOlw',
    src: 'https://www.youtube.com/embed/CJ7LQXgp81w',
    category: 'Stop Motion',
  },
  {
    _id: uuid(),
    thumbnail:
      'https://i.ytimg.com/vi/3a6A3_08jNo/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAJzraSVgeIfFINQtGxqh87dVqeZw',
    src: 'https://www.youtube.com/embed/3a6A3_08jNo',
    category: 'Pottery',
  },
  {
    _id: uuid(),
    thumbnail:
      'https://i.ytimg.com/vi/koWSpTFYLok/hqdefault.jpg?sqp=-oaymwEcCPYBEIoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBx_E-4zOrohXmMU5FGlv-zn-yTvg',
    src: 'https://www.youtube.com/embed/koWSpTFYLok',
    category: 'Quilling',
  },
]